import { authService } from "./authService";

// Save the original fetch function
const originalFetch = window.fetch;

// List of public routes that should not trigger login redirect on 401
const publicRoutes = ["/privacy-policy", "/about", "/login", "/register", "/reset-password"];

// Check if current path is a public route
const isPublicRoute = (path: string): boolean => {
  return publicRoutes.some((route) => path.startsWith(route));
};

// Create a wrapper for fetch that handles 401 responses
window.fetch = async function (input: RequestInfo | URL, init?: RequestInit) {
  try {
    // Call the original fetch
    const response = await originalFetch(input, init);

    // If response is 401 Unauthorized, redirect to login
    // But only if we're not on a public route
    if (response.status === 401) {
      const currentPath = window.location.pathname + window.location.search;

      // Don't redirect if we're on a public route
      if (isPublicRoute(currentPath)) {
        return response;
      }

      authService.handleUnauthorized(currentPath);
    }

    return response;
  } catch (error) {
    // Rethrow the error to be handled by the calling code
    throw error;
  }
};

export const setupFetchInterceptor = () => {
  // This function doesn't need to do anything since the interceptor
  // is set up when this module is imported, but it provides a clean API
  // for initializing the interceptor from App.tsx
};
